/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost,
  CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostParams,
  ContractAutomationApprovedSOWRequest,
  ContractAutomationArchiveSOWRequest,
  ContractAutomationContractContextResponse,
  ContractAutomationDriveExtractResponse,
  ContractAutomationDriveFilesResponse,
  ContractAutomationGmailSOWExtractRequest,
  ContractAutomationGmailSOWExtractResponse,
  ContractAutomationGmailSOWIntakeRequest,
  ContractAutomationGmailSOWIntakeResponse,
  ContractAutomationHubSpotDealsResponse,
  ContractAutomationHubSpotReadinessResponse,
  ContractAutomationHubSpotUpdateRequest,
  ContractAutomationOperatingPeopleResponse,
  ContractAutomationSheetSyncRequest,
  ContractAutomationSheetSyncResponse,
  ContractAutomationSlackNotifyRequest,
  ContractAutomationSlackNotifyResponse,
  ContractAutomationSlackRecipientsResponse,
  ContractAutomationSystemUpdateResponse,
  ExtractSowFromDriveApiContractAutomationDriveExtractGetParams,
  GetContractContextApiContractAutomationContractContextGetParams,
  GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
  HTTPValidationError,
  OperatingSowTestCleanupResponse,
  OperatingSowTestRequest,
  OperatingSowTestResponse,
} from ".././models";

import { customInstance } from "../../services/api-client";

/**
 * Send a test DM to the calling user via the tenant Slack connection.
 * @summary Test Slack Connection
 */
export const testSlackConnectionApiContractAutomationSlackTestPost = (
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationSlackNotifyResponse>({
    url: `/api/contract-automation/slack/test`,
    method: "POST",
    signal,
  });
};

export const getTestSlackConnectionApiContractAutomationSlackTestPostMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof testSlackConnectionApiContractAutomationSlackTestPost>
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof testSlackConnectionApiContractAutomationSlackTestPost>
    >,
    TError,
    void,
    TContext
  > => {
    const mutationKey = [
      "testSlackConnectionApiContractAutomationSlackTestPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof testSlackConnectionApiContractAutomationSlackTestPost>
      >,
      void
    > = () => {
      return testSlackConnectionApiContractAutomationSlackTestPost();
    };

    return { mutationFn, ...mutationOptions };
  };

export type TestSlackConnectionApiContractAutomationSlackTestPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof testSlackConnectionApiContractAutomationSlackTestPost>
    >
  >;

export type TestSlackConnectionApiContractAutomationSlackTestPostMutationError =
  unknown;

/**
 * @summary Test Slack Connection
 */
export const useTestSlackConnectionApiContractAutomationSlackTestPost = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof testSlackConnectionApiContractAutomationSlackTestPost>
      >,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof testSlackConnectionApiContractAutomationSlackTestPost>
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getTestSlackConnectionApiContractAutomationSlackTestPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List tenant-approved direct-message recipients; channel posting is not exposed.
 * @summary Get Slack Recipients
 */
export const getSlackRecipientsApiContractAutomationSlackRecipientsGet = (
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationSlackRecipientsResponse>({
    url: `/api/contract-automation/slack/recipients`,
    method: "GET",
    signal,
  });
};

export const getGetSlackRecipientsApiContractAutomationSlackRecipientsGetQueryKey =
  () => {
    return [`/api/contract-automation/slack/recipients`] as const;
  };

export const getGetSlackRecipientsApiContractAutomationSlackRecipientsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
      >
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSlackRecipientsApiContractAutomationSlackRecipientsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
        >
      >
    > = ({ signal }) =>
      getSlackRecipientsApiContractAutomationSlackRecipientsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSlackRecipientsApiContractAutomationSlackRecipientsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
      >
    >
  >;
export type GetSlackRecipientsApiContractAutomationSlackRecipientsGetQueryError =
  unknown;

export function useGetSlackRecipientsApiContractAutomationSlackRecipientsGet<
  TData = Awaited<
    ReturnType<typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet>
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSlackRecipientsApiContractAutomationSlackRecipientsGet<
  TData = Awaited<
    ReturnType<typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSlackRecipientsApiContractAutomationSlackRecipientsGet<
  TData = Awaited<
    ReturnType<typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Slack Recipients
 */

export function useGetSlackRecipientsApiContractAutomationSlackRecipientsGet<
  TData = Awaited<
    ReturnType<typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSlackRecipientsApiContractAutomationSlackRecipientsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSlackRecipientsApiContractAutomationSlackRecipientsGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Send a Contract Automation DM to the calling user's Slack account.
 * @summary Notify Via Slack
 */
export const notifyViaSlackApiContractAutomationSlackNotifyPost = (
  contractAutomationSlackNotifyRequest: ContractAutomationSlackNotifyRequest,
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationSlackNotifyResponse>({
    url: `/api/contract-automation/slack/notify`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: contractAutomationSlackNotifyRequest,
    signal,
  });
};

export const getNotifyViaSlackApiContractAutomationSlackNotifyPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof notifyViaSlackApiContractAutomationSlackNotifyPost>
      >,
      TError,
      { data: ContractAutomationSlackNotifyRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof notifyViaSlackApiContractAutomationSlackNotifyPost>
    >,
    TError,
    { data: ContractAutomationSlackNotifyRequest },
    TContext
  > => {
    const mutationKey = ["notifyViaSlackApiContractAutomationSlackNotifyPost"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof notifyViaSlackApiContractAutomationSlackNotifyPost>
      >,
      { data: ContractAutomationSlackNotifyRequest }
    > = (props) => {
      const { data } = props ?? {};

      return notifyViaSlackApiContractAutomationSlackNotifyPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type NotifyViaSlackApiContractAutomationSlackNotifyPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof notifyViaSlackApiContractAutomationSlackNotifyPost>
    >
  >;
export type NotifyViaSlackApiContractAutomationSlackNotifyPostMutationBody =
  ContractAutomationSlackNotifyRequest;
export type NotifyViaSlackApiContractAutomationSlackNotifyPostMutationError =
  HTTPValidationError;

/**
 * @summary Notify Via Slack
 */
export const useNotifyViaSlackApiContractAutomationSlackNotifyPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof notifyViaSlackApiContractAutomationSlackNotifyPost>
      >,
      TError,
      { data: ContractAutomationSlackNotifyRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof notifyViaSlackApiContractAutomationSlackNotifyPost>
  >,
  TError,
  { data: ContractAutomationSlackNotifyRequest },
  TContext
> => {
  const mutationOptions =
    getNotifyViaSlackApiContractAutomationSlackNotifyPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Sync populated contract context to a Google Sheets spreadsheet.
 * @summary Sync Contract Context To Google Sheets
 */
export const syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost =
  (
    contractAutomationSheetSyncRequest: ContractAutomationSheetSyncRequest,
    signal?: AbortSignal,
  ) => {
    return customInstance<ContractAutomationSheetSyncResponse>({
      url: `/api/contract-automation/google-sheets/sync`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contractAutomationSheetSyncRequest,
      signal,
    });
  };

export const getSyncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost
        >
      >,
      TError,
      { data: ContractAutomationSheetSyncRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost
      >
    >,
    TError,
    { data: ContractAutomationSheetSyncRequest },
    TContext
  > => {
    const mutationKey = [
      "syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost
        >
      >,
      { data: ContractAutomationSheetSyncRequest }
    > = (props) => {
      const { data } = props ?? {};

      return syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SyncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost
      >
    >
  >;
export type SyncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPostMutationBody =
  ContractAutomationSheetSyncRequest;
export type SyncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPostMutationError =
  HTTPValidationError;

/**
 * @summary Sync Contract Context To Google Sheets
 */
export const useSyncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost
          >
        >,
        TError,
        { data: ContractAutomationSheetSyncRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof syncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPost
      >
    >,
    TError,
    { data: ContractAutomationSheetSyncRequest },
    TContext
  > => {
    const mutationOptions =
      getSyncContractContextToGoogleSheetsApiContractAutomationGoogleSheetsSyncPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Scan Gmail subjects and download attachments for SOW-like emails.
 * @summary Test Gmail Sow Intake
 */
export const testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost = (
  contractAutomationGmailSOWIntakeRequest: ContractAutomationGmailSOWIntakeRequest,
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationGmailSOWIntakeResponse>({
    url: `/api/contract-automation/gmail/sow-intake/test`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: contractAutomationGmailSOWIntakeRequest,
    signal,
  });
};

export const getTestGmailSowIntakeApiContractAutomationGmailSowIntakeTestPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost
        >
      >,
      TError,
      { data: ContractAutomationGmailSOWIntakeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost
      >
    >,
    TError,
    { data: ContractAutomationGmailSOWIntakeRequest },
    TContext
  > => {
    const mutationKey = [
      "testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost
        >
      >,
      { data: ContractAutomationGmailSOWIntakeRequest }
    > = (props) => {
      const { data } = props ?? {};

      return testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TestGmailSowIntakeApiContractAutomationGmailSowIntakeTestPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost
      >
    >
  >;
export type TestGmailSowIntakeApiContractAutomationGmailSowIntakeTestPostMutationBody =
  ContractAutomationGmailSOWIntakeRequest;
export type TestGmailSowIntakeApiContractAutomationGmailSowIntakeTestPostMutationError =
  HTTPValidationError;

/**
 * @summary Test Gmail Sow Intake
 */
export const useTestGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost
          >
        >,
        TError,
        { data: ContractAutomationGmailSOWIntakeRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof testGmailSowIntakeApiContractAutomationGmailSowIntakeTestPost
      >
    >,
    TError,
    { data: ContractAutomationGmailSOWIntakeRequest },
    TContext
  > => {
    const mutationOptions =
      getTestGmailSowIntakeApiContractAutomationGmailSowIntakeTestPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Return a downloaded Gmail SOW PDF for authenticated in-app preview.
 * @summary Preview Downloaded Gmail Sow Attachment
 */
export const previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost =
  (
    contractAutomationGmailSOWExtractRequest: ContractAutomationGmailSOWExtractRequest,
    signal?: AbortSignal,
  ) => {
    return customInstance<unknown>({
      url: `/api/contract-automation/gmail/sow-intake/attachment-preview`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contractAutomationGmailSOWExtractRequest,
      signal,
    });
  };

export const getPreviewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost
        >
      >,
      TError,
      { data: ContractAutomationGmailSOWExtractRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost
      >
    >,
    TError,
    { data: ContractAutomationGmailSOWExtractRequest },
    TContext
  > => {
    const mutationKey = [
      "previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost
        >
      >,
      { data: ContractAutomationGmailSOWExtractRequest }
    > = (props) => {
      const { data } = props ?? {};

      return previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type PreviewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost
      >
    >
  >;
export type PreviewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPostMutationBody =
  ContractAutomationGmailSOWExtractRequest;
export type PreviewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Preview Downloaded Gmail Sow Attachment
 */
export const usePreviewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost
          >
        >,
        TError,
        { data: ContractAutomationGmailSOWExtractRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof previewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPost
      >
    >,
    TError,
    { data: ContractAutomationGmailSOWExtractRequest },
    TContext
  > => {
    const mutationOptions =
      getPreviewDownloadedGmailSowAttachmentApiContractAutomationGmailSowIntakeAttachmentPreviewPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Extract approval fields from a downloaded Gmail SOW PDF.
 * @summary Extract Downloaded Gmail Sow
 */
export const extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost =
  (
    contractAutomationGmailSOWExtractRequest: ContractAutomationGmailSOWExtractRequest,
    signal?: AbortSignal,
  ) => {
    return customInstance<ContractAutomationGmailSOWExtractResponse>({
      url: `/api/contract-automation/gmail/sow-intake/extract`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contractAutomationGmailSOWExtractRequest,
      signal,
    });
  };

export const getExtractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost
        >
      >,
      TError,
      { data: ContractAutomationGmailSOWExtractRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost
      >
    >,
    TError,
    { data: ContractAutomationGmailSOWExtractRequest },
    TContext
  > => {
    const mutationKey = [
      "extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost
        >
      >,
      { data: ContractAutomationGmailSOWExtractRequest }
    > = (props) => {
      const { data } = props ?? {};

      return extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ExtractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost
      >
    >
  >;
export type ExtractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPostMutationBody =
  ContractAutomationGmailSOWExtractRequest;
export type ExtractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPostMutationError =
  HTTPValidationError;

/**
 * @summary Extract Downloaded Gmail Sow
 */
export const useExtractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost
          >
        >,
        TError,
        { data: ContractAutomationGmailSOWExtractRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof extractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPost
      >
    >,
    TError,
    { data: ContractAutomationGmailSOWExtractRequest },
    TContext
  > => {
    const mutationOptions =
      getExtractDownloadedGmailSowApiContractAutomationGmailSowIntakeExtractPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Upload a signed SOW PDF manually and extract approval fields.
 * @summary Upload Manual Sow Pdf
 */
export const uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost =
  (
    bodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost: BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost,
    signal?: AbortSignal,
  ) => {
    const formData = new FormData();
    formData.append(
      `file`,
      bodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost.file,
    );

    return customInstance<ContractAutomationGmailSOWExtractResponse>({
      url: `/api/contract-automation/manual-sow/upload-extract`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    });
  };

export const getUploadManualSowPdfApiContractAutomationManualSowUploadExtractPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost
        >
      >,
      TError,
      {
        data: BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost
      >
    >,
    TError,
    {
      data: BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost;
    },
    TContext
  > => {
    const mutationKey = [
      "uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost
        >
      >,
      {
        data: BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost;
      }
    > = (props) => {
      const { data } = props ?? {};

      return uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UploadManualSowPdfApiContractAutomationManualSowUploadExtractPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost
      >
    >
  >;
export type UploadManualSowPdfApiContractAutomationManualSowUploadExtractPostMutationBody =
  BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost;
export type UploadManualSowPdfApiContractAutomationManualSowUploadExtractPostMutationError =
  HTTPValidationError;

/**
 * @summary Upload Manual Sow Pdf
 */
export const useUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost
          >
        >,
        TError,
        {
          data: BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost;
        },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof uploadManualSowPdfApiContractAutomationManualSowUploadExtractPost
      >
    >,
    TError,
    {
      data: BodyUploadManualSowPdfApiContractAutomationManualSowUploadExtractPost;
    },
    TContext
  > => {
    const mutationOptions =
      getUploadManualSowPdfApiContractAutomationManualSowUploadExtractPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Upload the accepted signed SOW PDF into the tenant's configured Drive folder.
 * @summary Archive Approved Sow To Drive
 */
export const archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost =
  (
    contractAutomationArchiveSOWRequest: ContractAutomationArchiveSOWRequest,
    signal?: AbortSignal,
  ) => {
    return customInstance<ContractAutomationSystemUpdateResponse>({
      url: `/api/contract-automation/drive/archive-approved-sow`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contractAutomationArchiveSOWRequest,
      signal,
    });
  };

export const getArchiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost
        >
      >,
      TError,
      { data: ContractAutomationArchiveSOWRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost
      >
    >,
    TError,
    { data: ContractAutomationArchiveSOWRequest },
    TContext
  > => {
    const mutationKey = [
      "archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost
        >
      >,
      { data: ContractAutomationArchiveSOWRequest }
    > = (props) => {
      const { data } = props ?? {};

      return archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost
      >
    >
  >;
export type ArchiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPostMutationBody =
  ContractAutomationArchiveSOWRequest;
export type ArchiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPostMutationError =
  HTTPValidationError;

/**
 * @summary Archive Approved Sow To Drive
 */
export const useArchiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost
          >
        >,
        TError,
        { data: ContractAutomationArchiveSOWRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof archiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPost
      >
    >,
    TError,
    { data: ContractAutomationArchiveSOWRequest },
    TContext
  > => {
    const mutationOptions =
      getArchiveApprovedSowToDriveApiContractAutomationDriveArchiveApprovedSowPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Return tenant-scoped, redacted HubSpot rollout readiness.
 * @summary Get Hubspot Write Readiness
 */
export const getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet =
  (signal?: AbortSignal) => {
    return customInstance<ContractAutomationHubSpotReadinessResponse>({
      url: `/api/contract-automation/hubspot/readiness`,
      method: "GET",
      signal,
    });
  };

export const getGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGetQueryKey =
  () => {
    return [`/api/contract-automation/hubspot/readiness`] as const;
  };

export const getGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
      >
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
        >
      >
    > = ({ signal }) =>
      getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetHubspotWriteReadinessApiContractAutomationHubspotReadinessGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
      >
    >
  >;
export type GetHubspotWriteReadinessApiContractAutomationHubspotReadinessGetQueryError =
  unknown;

export function useGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
    >
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
    >
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
    >
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Hubspot Write Readiness
 */

export function useGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGet<
  TData = Awaited<
    ReturnType<
      typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
    >
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHubspotWriteReadinessApiContractAutomationHubspotReadinessGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetHubspotWriteReadinessApiContractAutomationHubspotReadinessGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an exact deal, with mock-only creation retained for test tooling.
 * @summary Update Hubspot From Approved Sow
 */
export const updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost =
  (
    contractAutomationHubSpotUpdateRequest: ContractAutomationHubSpotUpdateRequest,
    signal?: AbortSignal,
  ) => {
    return customInstance<ContractAutomationSystemUpdateResponse>({
      url: `/api/contract-automation/hubspot/update-approved-sow`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contractAutomationHubSpotUpdateRequest,
      signal,
    });
  };

export const getUpdateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost
        >
      >,
      TError,
      { data: ContractAutomationHubSpotUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost
      >
    >,
    TError,
    { data: ContractAutomationHubSpotUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      "updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost
        >
      >,
      { data: ContractAutomationHubSpotUpdateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost
      >
    >
  >;
export type UpdateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPostMutationBody =
  ContractAutomationHubSpotUpdateRequest;
export type UpdateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPostMutationError =
  HTTPValidationError;

/**
 * @summary Update Hubspot From Approved Sow
 */
export const useUpdateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost
          >
        >,
        TError,
        { data: ContractAutomationHubSpotUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPost
      >
    >,
    TError,
    { data: ContractAutomationHubSpotUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateHubspotFromApprovedSowApiContractAutomationHubspotUpdateApprovedSowPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Create/update guarded Operating project, positions, and allocations from approved SOW fields.
 * @summary Update Operating From Approved Sow
 */
export const updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost =
  (
    contractAutomationApprovedSOWRequest: ContractAutomationApprovedSOWRequest,
    signal?: AbortSignal,
  ) => {
    return customInstance<ContractAutomationSystemUpdateResponse>({
      url: `/api/contract-automation/operating/update-approved-sow`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: contractAutomationApprovedSOWRequest,
      signal,
    });
  };

export const getUpdateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost
        >
      >,
      TError,
      { data: ContractAutomationApprovedSOWRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost
      >
    >,
    TError,
    { data: ContractAutomationApprovedSOWRequest },
    TContext
  > => {
    const mutationKey = [
      "updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost
        >
      >,
      { data: ContractAutomationApprovedSOWRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost(
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost
      >
    >
  >;
export type UpdateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPostMutationBody =
  ContractAutomationApprovedSOWRequest;
export type UpdateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPostMutationError =
  HTTPValidationError;

/**
 * @summary Update Operating From Approved Sow
 */
export const useUpdateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost
          >
        >,
        TError,
        { data: ContractAutomationApprovedSOWRequest },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPost
      >
    >,
    TError,
    { data: ContractAutomationApprovedSOWRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateOperatingFromApprovedSowApiContractAutomationOperatingUpdateApprovedSowPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List the current tenant's Operating people for explicit SOW staffing selection.
 * @summary List Operating People
 */
export const listOperatingPeopleApiContractAutomationOperatingPeopleGet = (
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationOperatingPeopleResponse>({
    url: `/api/contract-automation/operating/people`,
    method: "GET",
    signal,
  });
};

export const getListOperatingPeopleApiContractAutomationOperatingPeopleGetQueryKey =
  () => {
    return [`/api/contract-automation/operating/people`] as const;
  };

export const getListOperatingPeopleApiContractAutomationOperatingPeopleGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
      >
    >,
    TError = unknown,
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListOperatingPeopleApiContractAutomationOperatingPeopleGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
        >
      >
    > = ({ signal }) =>
      listOperatingPeopleApiContractAutomationOperatingPeopleGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListOperatingPeopleApiContractAutomationOperatingPeopleGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
      >
    >
  >;
export type ListOperatingPeopleApiContractAutomationOperatingPeopleGetQueryError =
  unknown;

export function useListOperatingPeopleApiContractAutomationOperatingPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
    >
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOperatingPeopleApiContractAutomationOperatingPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
    >
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOperatingPeopleApiContractAutomationOperatingPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
    >
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Operating People
 */

export function useListOperatingPeopleApiContractAutomationOperatingPeopleGet<
  TData = Awaited<
    ReturnType<
      typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
    >
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listOperatingPeopleApiContractAutomationOperatingPeopleGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListOperatingPeopleApiContractAutomationOperatingPeopleGetQueryOptions(
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Run the guarded live ZZZ-TEST SOW -> Operating proof.
 * @summary Run Operating Sow Test
 */
export const runOperatingSowTestApiContractAutomationOperatingTestRunPost = (
  operatingSowTestRequest: OperatingSowTestRequest,
  signal?: AbortSignal,
) => {
  return customInstance<OperatingSowTestResponse>({
    url: `/api/contract-automation/operating/test/run`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: operatingSowTestRequest,
    signal,
  });
};

export const getRunOperatingSowTestApiContractAutomationOperatingTestRunPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runOperatingSowTestApiContractAutomationOperatingTestRunPost
        >
      >,
      TError,
      { data: OperatingSowTestRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof runOperatingSowTestApiContractAutomationOperatingTestRunPost
      >
    >,
    TError,
    { data: OperatingSowTestRequest },
    TContext
  > => {
    const mutationKey = [
      "runOperatingSowTestApiContractAutomationOperatingTestRunPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof runOperatingSowTestApiContractAutomationOperatingTestRunPost
        >
      >,
      { data: OperatingSowTestRequest }
    > = (props) => {
      const { data } = props ?? {};

      return runOperatingSowTestApiContractAutomationOperatingTestRunPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunOperatingSowTestApiContractAutomationOperatingTestRunPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof runOperatingSowTestApiContractAutomationOperatingTestRunPost
      >
    >
  >;
export type RunOperatingSowTestApiContractAutomationOperatingTestRunPostMutationBody =
  OperatingSowTestRequest;
export type RunOperatingSowTestApiContractAutomationOperatingTestRunPostMutationError =
  HTTPValidationError;

/**
 * @summary Run Operating Sow Test
 */
export const useRunOperatingSowTestApiContractAutomationOperatingTestRunPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runOperatingSowTestApiContractAutomationOperatingTestRunPost
        >
      >,
      TError,
      { data: OperatingSowTestRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof runOperatingSowTestApiContractAutomationOperatingTestRunPost
    >
  >,
  TError,
  { data: OperatingSowTestRequest },
  TContext
> => {
  const mutationOptions =
    getRunOperatingSowTestApiContractAutomationOperatingTestRunPostMutationOptions(
      options,
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete allocations, positions, and the ZZZ-TEST project created by the proof run.
 * @summary Cleanup Operating Sow Test
 */
export const cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost =
  (
    projectId: string,
    params?: CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostParams,
    signal?: AbortSignal,
  ) => {
    return customInstance<OperatingSowTestCleanupResponse>({
      url: `/api/contract-automation/operating/test/${projectId}/cleanup`,
      method: "POST",
      params,
      signal,
    });
  };

export const getCleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost
        >
      >,
      TError,
      {
        projectId: string;
        params?: CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost
      >
    >,
    TError,
    {
      projectId: string;
      params?: CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      "cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost
        >
      >,
      {
        projectId: string;
        params?: CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostParams;
      }
    > = (props) => {
      const { projectId, params } = props ?? {};

      return cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost(
        projectId,
        params,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost
      >
    >
  >;

export type CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostMutationError =
  HTTPValidationError;

/**
 * @summary Cleanup Operating Sow Test
 */
export const useCleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost
          >
        >,
        TError,
        {
          projectId: string;
          params?: CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostParams;
        },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof cleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPost
      >
    >,
    TError,
    {
      projectId: string;
      params?: CleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostParams;
    },
    TContext
  > => {
    const mutationOptions =
      getCleanupOperatingSowTestApiContractAutomationOperatingTestProjectIdCleanupPostMutationOptions(
        options,
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List deals eligible for the Contract Sent to Closed Won transition.
 * @summary Get Hubspot Deals
 */
export const getHubspotDealsApiContractAutomationHubspotDealsGet = (
  params: GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationHubSpotDealsResponse>({
    url: `/api/contract-automation/hubspot/deals`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetHubspotDealsApiContractAutomationHubspotDealsGetQueryKey = (
  params?: GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
) => {
  return [
    `/api/contract-automation/hubspot/deals`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetHubspotDealsApiContractAutomationHubspotDealsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
    >,
    TError = HTTPValidationError,
  >(
    params: GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getHubspotDealsApiContractAutomationHubspotDealsGet
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetHubspotDealsApiContractAutomationHubspotDealsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
      >
    > = ({ signal }) =>
      getHubspotDealsApiContractAutomationHubspotDealsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetHubspotDealsApiContractAutomationHubspotDealsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
    >
  >;
export type GetHubspotDealsApiContractAutomationHubspotDealsGetQueryError =
  HTTPValidationError;

export function useGetHubspotDealsApiContractAutomationHubspotDealsGet<
  TData = Awaited<
    ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHubspotDealsApiContractAutomationHubspotDealsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHubspotDealsApiContractAutomationHubspotDealsGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHubspotDealsApiContractAutomationHubspotDealsGet<
  TData = Awaited<
    ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHubspotDealsApiContractAutomationHubspotDealsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHubspotDealsApiContractAutomationHubspotDealsGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHubspotDealsApiContractAutomationHubspotDealsGet<
  TData = Awaited<
    ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Hubspot Deals
 */

export function useGetHubspotDealsApiContractAutomationHubspotDealsGet<
  TData = Awaited<
    ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetHubspotDealsApiContractAutomationHubspotDealsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getHubspotDealsApiContractAutomationHubspotDealsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetHubspotDealsApiContractAutomationHubspotDealsGetQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Combined Drive SOW extraction + HubSpot deals + LLM summary for a client.
 * @summary Get Contract Context
 */
export const getContractContextApiContractAutomationContractContextGet = (
  params: GetContractContextApiContractAutomationContractContextGetParams,
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationContractContextResponse>({
    url: `/api/contract-automation/contract/context`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetContractContextApiContractAutomationContractContextGetQueryKey =
  (
    params?: GetContractContextApiContractAutomationContractContextGetParams,
  ) => {
    return [
      `/api/contract-automation/contract/context`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetContractContextApiContractAutomationContractContextGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getContractContextApiContractAutomationContractContextGet
      >
    >,
    TError = HTTPValidationError,
  >(
    params: GetContractContextApiContractAutomationContractContextGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getContractContextApiContractAutomationContractContextGet
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetContractContextApiContractAutomationContractContextGetQueryKey(
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getContractContextApiContractAutomationContractContextGet
        >
      >
    > = ({ signal }) =>
      getContractContextApiContractAutomationContractContextGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getContractContextApiContractAutomationContractContextGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetContractContextApiContractAutomationContractContextGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getContractContextApiContractAutomationContractContextGet
      >
    >
  >;
export type GetContractContextApiContractAutomationContractContextGetQueryError =
  HTTPValidationError;

export function useGetContractContextApiContractAutomationContractContextGet<
  TData = Awaited<
    ReturnType<typeof getContractContextApiContractAutomationContractContextGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetContractContextApiContractAutomationContractContextGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContractContextApiContractAutomationContractContextGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContractContextApiContractAutomationContractContextGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContractContextApiContractAutomationContractContextGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetContractContextApiContractAutomationContractContextGet<
  TData = Awaited<
    ReturnType<typeof getContractContextApiContractAutomationContractContextGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetContractContextApiContractAutomationContractContextGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContractContextApiContractAutomationContractContextGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getContractContextApiContractAutomationContractContextGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getContractContextApiContractAutomationContractContextGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetContractContextApiContractAutomationContractContextGet<
  TData = Awaited<
    ReturnType<typeof getContractContextApiContractAutomationContractContextGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetContractContextApiContractAutomationContractContextGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContractContextApiContractAutomationContractContextGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Contract Context
 */

export function useGetContractContextApiContractAutomationContractContextGet<
  TData = Awaited<
    ReturnType<typeof getContractContextApiContractAutomationContractContextGet>
  >,
  TError = HTTPValidationError,
>(
  params: GetContractContextApiContractAutomationContractContextGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getContractContextApiContractAutomationContractContextGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetContractContextApiContractAutomationContractContextGetQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List files and text previews from the tenant's Google Drive folder.
 * @summary List Drive Files
 */
export const listDriveFilesApiContractAutomationDriveFilesGet = (
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationDriveFilesResponse>({
    url: `/api/contract-automation/drive/files`,
    method: "GET",
    signal,
  });
};

export const getListDriveFilesApiContractAutomationDriveFilesGetQueryKey =
  () => {
    return [`/api/contract-automation/drive/files`] as const;
  };

export const getListDriveFilesApiContractAutomationDriveFilesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
  >,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListDriveFilesApiContractAutomationDriveFilesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>>
  > = ({ signal }) => listDriveFilesApiContractAutomationDriveFilesGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
    >,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListDriveFilesApiContractAutomationDriveFilesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>>
  >;
export type ListDriveFilesApiContractAutomationDriveFilesGetQueryError =
  unknown;

export function useListDriveFilesApiContractAutomationDriveFilesGet<
  TData = Awaited<
    ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
  >,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListDriveFilesApiContractAutomationDriveFilesGet<
  TData = Awaited<
    ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListDriveFilesApiContractAutomationDriveFilesGet<
  TData = Awaited<
    ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Drive Files
 */

export function useListDriveFilesApiContractAutomationDriveFilesGet<
  TData = Awaited<
    ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
  >,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listDriveFilesApiContractAutomationDriveFilesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListDriveFilesApiContractAutomationDriveFilesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Extract SOW fields from files in the tenant's Google Drive folder.
 * @summary Extract Sow From Drive
 */
export const extractSowFromDriveApiContractAutomationDriveExtractGet = (
  params?: ExtractSowFromDriveApiContractAutomationDriveExtractGetParams,
  signal?: AbortSignal,
) => {
  return customInstance<ContractAutomationDriveExtractResponse>({
    url: `/api/contract-automation/drive/extract`,
    method: "GET",
    params,
    signal,
  });
};

export const getExtractSowFromDriveApiContractAutomationDriveExtractGetQueryKey =
  (params?: ExtractSowFromDriveApiContractAutomationDriveExtractGetParams) => {
    return [
      `/api/contract-automation/drive/extract`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getExtractSowFromDriveApiContractAutomationDriveExtractGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof extractSowFromDriveApiContractAutomationDriveExtractGet>
    >,
    TError = HTTPValidationError,
  >(
    params?: ExtractSowFromDriveApiContractAutomationDriveExtractGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof extractSowFromDriveApiContractAutomationDriveExtractGet
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getExtractSowFromDriveApiContractAutomationDriveExtractGetQueryKey(
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof extractSowFromDriveApiContractAutomationDriveExtractGet
        >
      >
    > = ({ signal }) =>
      extractSowFromDriveApiContractAutomationDriveExtractGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof extractSowFromDriveApiContractAutomationDriveExtractGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ExtractSowFromDriveApiContractAutomationDriveExtractGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof extractSowFromDriveApiContractAutomationDriveExtractGet>
    >
  >;
export type ExtractSowFromDriveApiContractAutomationDriveExtractGetQueryError =
  HTTPValidationError;

export function useExtractSowFromDriveApiContractAutomationDriveExtractGet<
  TData = Awaited<
    ReturnType<typeof extractSowFromDriveApiContractAutomationDriveExtractGet>
  >,
  TError = HTTPValidationError,
>(
  params:
    | undefined
    | ExtractSowFromDriveApiContractAutomationDriveExtractGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof extractSowFromDriveApiContractAutomationDriveExtractGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof extractSowFromDriveApiContractAutomationDriveExtractGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof extractSowFromDriveApiContractAutomationDriveExtractGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useExtractSowFromDriveApiContractAutomationDriveExtractGet<
  TData = Awaited<
    ReturnType<typeof extractSowFromDriveApiContractAutomationDriveExtractGet>
  >,
  TError = HTTPValidationError,
>(
  params?: ExtractSowFromDriveApiContractAutomationDriveExtractGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof extractSowFromDriveApiContractAutomationDriveExtractGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof extractSowFromDriveApiContractAutomationDriveExtractGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof extractSowFromDriveApiContractAutomationDriveExtractGet
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useExtractSowFromDriveApiContractAutomationDriveExtractGet<
  TData = Awaited<
    ReturnType<typeof extractSowFromDriveApiContractAutomationDriveExtractGet>
  >,
  TError = HTTPValidationError,
>(
  params?: ExtractSowFromDriveApiContractAutomationDriveExtractGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof extractSowFromDriveApiContractAutomationDriveExtractGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Extract Sow From Drive
 */

export function useExtractSowFromDriveApiContractAutomationDriveExtractGet<
  TData = Awaited<
    ReturnType<typeof extractSowFromDriveApiContractAutomationDriveExtractGet>
  >,
  TError = HTTPValidationError,
>(
  params?: ExtractSowFromDriveApiContractAutomationDriveExtractGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof extractSowFromDriveApiContractAutomationDriveExtractGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getExtractSowFromDriveApiContractAutomationDriveExtractGetQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
